import { IFetchChecklistTemplatesParams } from 'APIPackage/AccountModule/services/checklistTemplatesApi';

export const getTemplatesGroupStoreKey = (params: IFetchChecklistTemplatesParams) => {
  const { needQuestions: isNeedQuestions, filter, order, page, shift, size } = params;
  const keyArray = [];
  const isNeedQuestionsValue = isNeedQuestions || false;

  keyArray.push(`needQuestions=${isNeedQuestionsValue}`);
  if (order) {
    keyArray.push(`order=${order}`);
  }
  if (page) {
    keyArray.push(`page=${page}`);
  }
  if (shift) {
    keyArray.push(`shift=${shift}`);
  }
  if (size) {
    keyArray.push(`size=${size}`);
  }
  if (filter) {
    const filterValuesArray: string[] = [];

    filter.forEach(filterValue => filterValuesArray.push(filterValue));
    keyArray.push(`filter=${filterValuesArray.join(',')}`);
  }

  return keyArray.join('/');
};
